export default __webpack_public_path__ + "static/media/Snd2.e23464a7.mp3";